import CompanyOutlookSectionBottomContent from "./bottom-content";
import CompanyOutlookSectionTopContent from "./top-content";


const CompanyOutlookSection = () => {
  return (
    <section className="flex flex-col items-center px-8 py-16 md:p-12 space-y-10 md:space-y-12">
      <CompanyOutlookSectionTopContent />
      <CompanyOutlookSectionBottomContent />
    </section>
  );
};

export default CompanyOutlookSection;
